import React from "react";
// import { robots } from "./robots";
import Card from "./robo";

const Cardlist = ({robots}) =>{
//   if(true){
//     throw new Error('Noooooo')
//   } 

  return (
        <div>

         {

            robots.map((user,i) => {
            return (  
                <Card key = {i} 
                id={robots[i].id} 
                name={robots[i].name} 
                email={robots[i].email}/>
             )
          }
        )
    
        }
        
                        
                   
       </div>
    )
  
}

export default Cardlist ;

// to avoid repation writing  Card id={robots[2].id} name={robots[2].name} email={robots[2].email}/>....
// using map to over come 

//here robot sare pure componets or dumb compoents , ther recive some thing and return it >. no need to woory about others

// props never change >
// but in serachbox we type differnt name s,which keep changing so we use State
//state which describes our application is the robots abd whatever we enter in the search box we get those
// we have to change the state of search box so we use onsearchchange function and setstate to change the state of searchbox
// 
// state are smartcomponets whih had class 
